import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function RequireOwner({ children }) {
  const { user, role, profile, claimsReady, profileReady, loading, logout } = useAuth();

  if (loading || !claimsReady || (user && !profileReady)) {
    return <div className="page-loading">جاري التحقق من الصلاحيات...</div>;
  }

  if (!user) {
    return <Navigate to="/admin" replace />;
  }

  if (role === "ADMIN" || role === "DEVELOPER" || role === "SUPER_ADMIN") {
    return <Navigate to="/admin" replace />;
  }

  if (role !== "CHALET_OWNER" || profile?.role !== "CHALET_OWNER") {
    return <Navigate to="/admin" replace />;
  }

  if (!profile || profile.status === "disabled") {
    logout();
    return <Navigate to="/admin" replace />;
  }

  return children;
}
